export default __webpack_public_path__ + "static/media/mail.42fd27a7.gif";